import { useAppStore } from '@/store'
import dayjs from 'dayjs'

interface TObject {
  [key:string]: any
}

/**
 * 对象分配-按key分配,用于向目标对象更新key对应的值
 * @param target Proxy
 * @param object Object
 */
export function assign (target: TObject, object:TObject) {
  Object.keys(object).forEach(key => {
    target[key] = object[key]
  })
}

/**
 * 是否含有权限
 * @param perm
 * @returns
 */
export function usePermission (perm:string) {
  const { authList } = useAppStore()
  return !authList.includes(perm)
}

/**
 * 格式化大小
 * @param size
 */
export function formatSize (size: number): string {
  let unit = 'B'
  let result = size
  if (result / 1024 > 1) {
    unit = 'KB'
    result = result / 1024
  }
  if (result / 1024 > 1) {
    unit = 'MB'
    result = result / 1024
  }
  return parseFloat(result.toFixed(1)) + unit
}

export function formatFileType (type: string): string {
  if (type.startsWith('application/')) {
    return '文件'
  } else if (type.startsWith('text/')) {
    return '文本'
  } else if (type.startsWith('video/')) {
    return '视频'
  } else if (type.startsWith('audio/')) {
    return '音频'
  } else {
    return '文件'
  }
}

/**
 * 校验字符串是否符合版本号规则
 * @param {string} value
 * @return {boolean}
 */
export function checkValueConformanceForVersion (value: string): boolean {
  return /^(([0-9]|([1-9]([0-9]*))).){2}([0-9]|([1-9]([0-9]*)))([-](([0-9A-Za-z]|([1-9A-Za-z]([0-9A-Za-z]*)))[.]){0,}([0-9A-Za-z]|([1-9A-Za-z]([0-9A-Za-z]*)))){0,1}([+](([0-9A-Za-z]{1,})[.]){0,}([0-9A-Za-z]{1,})){0,1}$/.test(value)
}

export function formatDate (
  time: number|string,
  format = 'YYYY-MM-DD HH:mm:ss'
): string {
  return dayjs(time).format(format)
}
/**
 * 复制文本到粘帖版
 * @param {string} text 要复制的文本
 */
export async function copyToClipboard (text: string): Promise<void> {
  try {
    // 尝试将文本写入剪贴板
    await navigator.clipboard.writeText(text)
  } catch (error) {
    console.error('Failed to copy text: ', error)
  }
}

export default null
